var exports = {
  "kL": "xa15a2ab7--bc39d7--container",
  "DD": "xa15a2ab7--bc39d7--title",
  "p_": "xa15a2ab7--bc39d7--list",
  "AS": "xa15a2ab7--bc39d7--item",
};

module.exports = exports;
